export default __webpack_public_path__ + "static/media/MONUSCO_SRSG_visits_kitshanga.85a52048.jpg";